// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1HeAk","productName":"Table_productName__3SwlN"};